import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=26e52a28&scoped=true&lang=pug"
import script from "./parts.vue?vue&type=script&lang=js"
export * from "./parts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e52a28",
  null
  
)

export default component.exports